import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigurationService } from '../services/configuration.service';

/**
 * Keeps client-portal routes unreachable, not just unlisted, when the tenant's
 * `clientPortal` capability is off (MP-5715). The sidenav hides the entry on
 * the same flag; this guard covers a typed URL or a stale bookmark.
 */
export const clientPortalGuard: CanActivateFn = () => {
  const configurationService = inject(ConfigurationService);
  const router = inject(Router);

  return configurationService.isClientPortalEnabled() ? true : router.createUrlTree(['/client/overview']);
};
